import axios from 'axios';

const apiUrl = process.env.REACT_APP_API_URL;

const PartnerPageService = {
  loadGuide: () => axios.get(`${apiUrl}/Partner/Guide`).catch(() => null),
  loadConfiguration: () => axios.get(`${apiUrl}/Partner/Configuration`).catch(() => null),
  loadUsers: () => axios.get(`${apiUrl}/Partner/User`).catch(() => null),
};

export default PartnerPageService;
